<div class="horizontal">
  <span>
    <button class="iconf-btn-blank" [ngClass]="{ active: isExpanded }" (click)="isExpanded = !isExpanded">
      <mat-icon>sort</mat-icon> filter by<mat-icon>{{ isExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
    </button>
  </span>
  <span>
    <button class="iconf-btn-blank" (click)="showGridview.emit(true)">
      <mat-icon class="material-icons-round">grid_view</mat-icon>
    </button>
    <button class="iconf-btn-blank" (click)="showGridview.emit(false)">
      <mat-icon class="material-icons-round">menu</mat-icon>
    </button>
  </span>
  @if (displaySearchField) {
  <div class="project-search">
    <div class="input-wrapper">
      <input
        id="project-search-input"
        placeholder="search by project name"
        #projectSearch
        class="input"
        [value]="filterValues.name ? filterValues.name : ''"
        (keyup.enter)="setFilterValue(projectSearch.value, 'name')"
      />
      @if (projectSearch.value) {
      <button class="iconf-btn-blank clear" aria-label="Clear" (click)="projectSearch.value = ''; setFilterValue(null, 'name')">
        <mat-icon>close</mat-icon>
      </button>
      }
    </div>
    <button class="search-button" (click)="setFilterValue(projectSearch.value ? projectSearch.value : null, 'name')">
      <mat-icon>search</mat-icon>
    </button>
  </div>
  }
</div>
@if (projects) {
<div class="dropdowns-container" [ngClass]="{ active: isExpanded }">
  @for (filter of filters; track filter) {
  <mat-form-field class="iconf-select" appearance="outline">
    <mat-select
      [value]="filterValues[filter.filterProperty]"
      (selectionChange)="setFilterValue($event.value, filter.filterProperty)"
      [placeholder]="filter.label"
    >
      @for (pair of projects | DistinctProjectValues: filter:filterValues | keyvalue; track pair) {
      <mat-option [value]="pair.value">{{ pair.key }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
</div>
}
